import React from "react";
import "./MerchantApiKeys.css";

const RotateMsg = ({ onConfirm, onCancel, username }) => {
  return (
    <div className="confirmation-modal-rotate">
      <div className="confirmation-content-rotate">
        <p>
          Are you sure you want to rotate the API key for{" "}
          <strong>{username}</strong>?
        </p>
        <div className="confirmation-buttons-rotate">
          <button onClick={onConfirm}>Yes</button>
          <button id ="confirmation-buttons" onClick={onCancel}>No</button>
        </div>
      </div>
    </div>
  );
};

export default RotateMsg;
